import * as firebase from 'firebase/app';
//import { resolve } from 'dns';
//import { rejects } from 'assert';
import 'firebase/auth';
import 'firebase/database';

var firebaseConfig = {
    apiKey: "AIzaSyCs0oFeNKU7sNKzD5WXgI-vMCSkZGWPZos",
    authDomain: "react-medical.firebaseapp.com",
    databaseURL: "https://react-medical.firebaseio.com",
    projectId: "react-medical",
    storageBucket: "react-medical.appspot.com",
    messagingSenderId: "795779282325",
    appId: "1:795779282325:web:609b33b5c25b6268f5329c",
    measurementId: "G-KF7DQ0B4JY"
  };

firebase.initializeApp(firebaseConfig);

export async function getCurrentUser() {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                resolve(user)
            } else {
                resolve(null)
            }
            unsubscribe()
        })
    })
    
}

export async function loginUser(username, password) {

    const email = `${username}@krneki.com`;
    try {
        const res = await firebase.auth().signInWithEmailAndPassword(email, password)
        
        console.log(res);
        return res
    } catch(error) {
        console.log(error.message) // BIL TOAST
        return false
    }
}

export async function registerUser(username, password) {
    const email = `${username}@krneki.com`;
    try {
        const res = await firebase.auth().createUserWithEmailAndPassword(email, password)
        
        console.log(res)
        return true
    } catch(error) {
        console.log(error.message) // BIL TOAST
        return false
    }
}

export function logoutUser() {
    return firebase.auth().signOut();
}